AGADash.Filter.Date = (function () {

    var rangeChanged = function (e) {
        AGADash.Panel.cancelSchedule();

        var me = $(e.target).closest('.dash-filter');
        var filterId = $(me).attr('filter-id');

        var start = $(me).find('input[name="start"]').first().val();
        var end = $(me).find('input[name="end"]').first().val();

        var key = "";
        if (start)
            key = "daterange|" + filterId + "|" + start + "-" + end + "|";

        $(me).attr("filter-user-key", key);
        AGADash.Panel.scheduleUpdate(e.target);
    };

    var selectDate = function (e) {
        var t = $(e.target).closest("li");
        var start = $(t).attr("data-start");
        var end = $(t).attr("data-end");
        var me = $(e.target).closest(".dash-filter");
        $(me).find('input[name="start"]').val(start);
        $(me).find('input[name="end"]').val(end);
        $(me).find('input[name="end"]').trigger("change");
    };

    var initRangeFilter = function (target) {
        var obj = $(target).datepicker({
            format: "dd/mm/yyyy",
            todayBtn: "linked",
            clearBtn: true,
            language: "pt-BR",
            autoclose: true
        });

        obj.on("change", rangeChanged);
        $(target).on("click", "li[data-start]", selectDate);
    };

    var renderDateOptions = function (placeHolder, periodos) {
        if (!periodos || periodos.length === 0)
            return;

        for (var i = 0; i < periodos.length; i++) {
            var parts = periodos[i].split('|');
            if (parts.length === 3) {
                var text = parts[0];
                var start = parts[1];
                var end = parts[2];

                var li = document.createElement("li");
                $(li).attr({
                    "data-start": start,
                    "data-end": end
                }).appendTo(placeHolder);
                var a = document.createElement("a");
                $(a).attr("href", "javascript:;").text(text).appendTo(li);
            }
        }
    };

    var renderFilter = function (placeHolder, filterInfo) {
        var div = document.createElement("div");
        $(div).addClass("input-daterange input-group dash-filter-range");
        var input = document.createElement("input");
        $(input).addClass("input-sm form-control").attr({
            "type": "text",
            "name": "start"
        }).appendTo(div);

        var span = document.createElement("span");
        $(span).addClass("input-group-addon btn-sm").text("até").appendTo(div);

        input = document.createElement("input");
        $(input).addClass("input-sm form-control").attr({
            "type": "text",
            "name": "end"
        }).appendTo(div);

        var btnGroup = document.createElement("div");
        $(btnGroup).addClass("input-group-btn").appendTo(div);
        var btn = document.createElement("button");
        $(btn).addClass("btn btn-sm dropdown-toggle").attr({
            "type": "button",
            "data-toggle": "dropdown",
            "aria-expanded": "false"
        })
            .appendTo(btnGroup);
        var i = document.createElement("i");
        $(i).addClass("fa fa-angle-down").appendTo(btn);

        var ul = document.createElement("ul");
        $(ul).addClass("dropdown-menu pull-right").appendTo(btnGroup);
        renderDateOptions(ul, filterInfo.Periodos);

        $(div).appendTo(placeHolder);
        initRangeFilter(div);

    };

    return {
        renderFilter: renderFilter
    };


})();
AGADash.Filter.setFilterClass("data", AGADash.Filter.Date);
